import React, { useEffect, useState } from 'react';
import { host_url } from '../../App'; // Import host_url
import './finanzamt.css';
import '../ListenSubpage.css';
import '../../styles/CiTable.css';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';

function Finanzamt() {
  const [einheiten, setEinheiten] = useState([]);
  const [selectedEinheit, setSelectedEinheit] = useState('');
  const [selectedEinheitName, setSelectedEinheitName] = useState('');
  const [daten, setDaten] = useState([]);
  const [columns, setColumns] = useState({
    Zeltname: true,
    Kindname: true,
    Job: true,
    Ganztagesjob: true,
    Überstunden: true,
    Bezahlt: true,
  });

  const handleColumnChange = (column) => {
    setColumns(prevColumns => ({
      ...prevColumns,
      [column]: !prevColumns[column]
    }));
  };

  useEffect(() => {
    fetch(`${host_url}/einheiten`)
      .then(response => response.json())
      .then(data => setEinheiten(data))
      .catch(error => console.error('Error fetching einheiten:', error));
  }, []);

  useEffect(() => {
    if (selectedEinheit) {
      const einheit = einheiten.find(e => e.ID === selectedEinheit);
      setSelectedEinheitName(einheit ? einheit.Name : '');
      fetch(`${host_url}/zuteilungen?einheitId=${selectedEinheit}`)
        .then(response => response.json())
        .then(data => setDaten(data))
        .catch(error => console.error('Error fetching zuteilungen:', error));
    } else {
      setSelectedEinheitName('');
      fetch(`${host_url}/zuteilungen`)
        .then(response => response.json())
        .then(data => setDaten(data))
        .catch(error => console.error('Error fetching zuteilungen:', error));
    }
  }, [selectedEinheit, einheiten]);

  return (
    <KernteamLayout>
    <div className="container">
      <BackArrow to="/listen" />
      <h1 className="section-title blue">Finanzamt Druck</h1>
      <main>
        {selectedEinheitName && <h3 className="">Ausgewählte Einheit: {selectedEinheitName}</h3>}
        <form className="no-print">
          <label htmlFor="einheit">Einheit</label>
          <div className={`dropdown-wrapper ${selectedEinheit ? 'filled' : ''}`}>
            <select name="einheit" id="einheit" value={selectedEinheit} onChange={e => setSelectedEinheit(e.target.value)}>
              <option value="">Alle Einheiten</option>
              {einheiten.map(einheit => (
                <option key={einheit.ID} value={einheit.ID}>{einheit.Name}</option>
              ))}
            </select>
            <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
          </div>
          <div className="checkbox-container">
          <h4>Wähle aus, welche Spalten angezeigt werden sollen</h4>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Zeltname} onChange={() => handleColumnChange('Zeltname')} />
              Zeltname
            </label>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Kindname} onChange={() => handleColumnChange('Kindname')} />
              Kindname
            </label>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Job} onChange={() => handleColumnChange('Job')} />
              Job
            </label>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Ganztagesjob} onChange={() => handleColumnChange('Ganztagesjob')} />
              Ganztagesjob
            </label>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Überstunden} onChange={() => handleColumnChange('Überstunden')} />
              Überstunden
            </label>
            <label className="checkbox-green">
              <input type="checkbox" checked={columns.Bezahlt} onChange={() => handleColumnChange('Bezahlt')} />
              Bezahlt
            </label>
          </div>
        </form>
        {daten.length > 0 ? (
          <>
            <div className="table-header">
              <h2>Finanzamt</h2>
              <span className="print-link no-print" onClick={() => window.print()}>
                <span className="material-symbols-outlined">print</span>
                <span className="print-text">Drucken</span>
              </span>
            </div>
            <div className="ci-table-wrapper">
            <table className="ci-table">
            <thead>
              <tr>
                {columns.Zeltname && <th>Zeltname</th>}
                {columns.Kindname && <th>Kindname</th>}
                {columns.Job && <th>Job</th>}
                {columns.Ganztagesjob && <th>Ganztagesjob</th>}
                {columns.Überstunden && <th>Überstunden</th>}
                {columns.Bezahlt && <th>Bezahlt</th>}
              </tr>
            </thead>
            <tbody>
              {daten.map((row, index) => (
                <tr key={index} className="tent-row">
                  {columns.Zeltname && <td>{row.ZeltName}</td>}
                  {columns.Kindname && <td>{row.KindName}</td>}
                  {columns.Job && <td>{row.JobName}</td>}
                  {columns.Ganztagesjob && <td>{row.Ganztagesjob ? 'Ja' : 'Nein'}</td>}
                  {columns.Überstunden && <td>{row.Ueberstunden ? 'Ja' : 'Nein'}</td>}
                  {columns.Bezahlt && <td></td>} {/* Leeres Feld für "Bezahlt" */}
                </tr>
              ))}
            </tbody>
            </table>
            </div>
          </>
        ) : (
          <p>Keine Daten gefunden.</p>
        )}
      </main>
    </div>
    </KernteamLayout>
  );
}

export default Finanzamt;